import React, { useEffect, useState } from 'react';
import { Alert, Snackbar } from '@mui/material';

import { AVIATIONWEATHER_ERROR } from '../utilities/enums';

export const AviationWeatherAlert = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const show = () => setOpen(true);
    window.addEventListener(AVIATIONWEATHER_ERROR, show);
    return () => window.removeEventListener(AVIATIONWEATHER_ERROR, show);
  }, []);

  return (
    <Snackbar
      open={open}
      onClose={(_, reason) => reason !== 'clickaway' && setOpen(false)}
      autoHideDuration={10000}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert severity='warning' onClose={() => setOpen(false)}>
        AviationWeather.gov is having problems. METAR, TAF and SIGMET may be
        missing or outdated. Try again in a few minutes.
      </Alert>
    </Snackbar>
  );
};
